var TransactionJourneyPresenter = /** @class */ (function () {
    function TransactionJourneyPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    TransactionJourneyPresenter.prototype.fixingDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.fixingDetails.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.fixingDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.isinClientDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.isinClientDetails.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.isinClientDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getBankCode = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getBankCode.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getBankCode(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getDraftOrderDeclarations = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.draftOrderDeclarations.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getDraftOrderDeclarations(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.saveDocs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveDocs.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.saveDocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.saveOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveOrder.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.saveOrder(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getEmpPartnerDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getEmpPartnerDetails.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getEmpPartnerDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getBankDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getBankDetails.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getBankDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getClientSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getClientSearch.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getClientSearch(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getRecentClientSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getRecentClientSearch.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getRecentClientSearch(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.saveRecentClientSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveRecentClientSearch.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.saveRecentClientSearch(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getDpDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.dpDetailsList.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getDpDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.saveDraftOrder = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.draftOrder.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.saveDraftOrder(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getDraftOrderDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.draftOrderDetails.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getDraftOrderDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.previewDraftDocs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.previewDraftDocs.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.previewDraftDocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.deletedDraftDocs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.deletedDraftDocs.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.deletedDraftDocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.saveDraftDocs = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.saveDraftDocs.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.savedDraftDocs(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.getDirtyDetails = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.dirtyPriceDetails.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.getDirtyPriceDetails(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.validateQuantity = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateQuantity.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.validateQuantity(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.validateDirtyPrice = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateDirtyPrice.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.validateDirtyPrice(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    TransactionJourneyPresenter.prototype.validateSetUpFeesAmount = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateSetUpFeesAmount.execute({
                onSuccess: function (data) {
                    _this.actions.transactionJourney.validateSetUpFees(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.productBouquet.userUnauthorized(error);
                    reject(error);
                },
            }, req);
        });
    };
    return TransactionJourneyPresenter;
}());
export default TransactionJourneyPresenter;
